<!-- @format -->

@if (value > 0) {
  <div class="notification-badge">{{ value }}</div>
}
